import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { message } from "antd";
import ConfirmModal from "components/Modals/ConfirmModal";
import FaiBox from "MuiComponents/FaiBox";
import FaiButton from "MuiComponents/FaiButton";
import React, { useState } from "react";

const Declaration = ({ onClose }) => {
	const [isAgreed, setIsAgreed] = useState(false);

	const handleSubmit = () => {
		if (isAgreed) {
			console.log("Form submitted successfully!");
		} else {
			message.error("Please agree to the declaration.");
		}
	};

	return (
		<ConfirmModal
			title={
				<Typography variant="h5" className="!mt-2 !text-xl !font-medium">
					Declaration
				</Typography>
			}
			handleCancel={onClose}
			visible={true}
			footer={false}
			body={
				<FaiBox className="p-3">
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Typography className="text-left !text-base !font-normal !leading-6">
								I hereby declare that the information provided on this website
								is true, accurate, and complete to the best of my knowledge and
								belief.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography className="text-left !text-base !font-normal !leading-6">
								I understand that providing false or misleading information may
								result in consequences as outlined by the website's terms and
								conditions.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography className="text-left !text-base !font-normal !leading-6">
								By submitting this form, I acknowledge that:
								<ul className="ml-4" style={{ listStyle: "disc" }}>
									<li>
										I have read and understood the terms and conditions of the
										website.
									</li>
									<li>The information provided is accurate and complete.</li>
									<li>I may be contacted for verification purposes.</li>
								</ul>
							</Typography>
						</Grid>
						<Grid item xs={12} sx={{ px: 1 }}>
							<FormControlLabel
								className="text-left"
								control={
									<Checkbox
										checked={isAgreed}
										onChange={() => setIsAgreed(!isAgreed)}
									/>
								}
								label="I agree to the above declaration."
								classes={{
									label: "text-theme",
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<FaiButton
								color="dark"
								onClick={handleSubmit}
								disabled={!isAgreed}
							>
								Continue
							</FaiButton>
						</Grid>
					</Grid>
				</FaiBox>
			}
		/>
	);
};
export default Declaration;
